import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Registro Fotografico',
    path: 'registro-fotografico',
    name: 'registrofotografico',
    component: () => import('@/views/gestao/registro-fotografico/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.Administrativo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusao de Registro Fotografico',
    path: 'registro-fotografico/incluir',
    parent: 'registrofotografico',
    name: 'registrofotograficoinsert',
    component: () => import('@/views/gestao/registro-fotografico/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'registrofotografico',
      permissions: [EPermissoes.Administrativo],
      grupos: []
    }
  },
  {
    description: 'Edicao de Registro Fotografico',
    path: 'registro-fotografico/editar/:id',
    parent: 'registrofotografico',
    name: 'RegistroFotograficoupdate',
    component: () => import('@/views/gestao/registro-fotografico/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'registrofotografico',
      permissions: [EPermissoes.Administrativo],
      grupos: []
    }
  }
];
